var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8546 4.18991C13.0616 4.42778 13.0457 4.79675 12.8191 5.01403L6.73726 10.8474C6.51587 11.0597 6.17395 11.0493 5.96468 10.8238L3.15767 7.79908C2.94353 7.56834 2.94809 7.19903 3.16784 6.97419C3.38759 6.74936 3.73931 6.75414 3.95345 6.98487L6.38505 9.60504L12.0698 4.15264C12.2963 3.93536 12.6477 3.95205 12.8546 4.18991Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.17b01db1e931aa048586110282f07348.svg";
export { ForwardRef as ReactComponent };